/* eslint-disable import/order */
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { includes, isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import { DWTCContext } from '../utils/context';

import {
  SectionCampus,
  SectionCaption,
  SliderWrapper,
  ThumbNailSlider,
  SlickSlide,
  CampusImageMobile,
  CampusImg,
  MobilePortrait,
  CampusImage,
} from './styles/CampusSlider.styled';

export default function OurCampusCarousel({ data, id, dir }) {
  const { text, title, ourCampusImages, mobileRotateMessage, mobileImage } = data;
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  const { cssClass } = React.useContext(DWTCContext);
  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  const theme = getTheme();

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    // rtl: slickDir,
    asNavFor: '.slider-nav',
    verticalSwiping: true,
  };

  const settingsThumbs = {
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    swipeToSlide: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };

  return (
    <SectionCampus id={id}>
      <SectionCaption dir={dir}>
        <Container dir={dir}>
          <h2 dir={dir}>{title}</h2>
          <p dir={dir}>{text}</p>
        </Container>
      </SectionCaption>

      <SliderWrapper className="slider-wrapper">
        <CampusImage dir={dir}>
          <Slider
            {...settingsMain}
            className="slider-full"
            asNavFor={nav2}
            ref={(slider) => setSlider1(slider)}
          >
            {ourCampusImages.map((image) => (
              <div>
              {isEmpty(image.content.image) || (
              <LazyLoadImage
                key={id}
                width={1920}
                height="100%"
                src={image.content.image.url}
                placeholderSrc={
                  image.content.image ? `${image.content.image.url}?width=50&quality=50` : null
                }
                effect="blur"
              />
              )}
              </div>
            ))}
          </Slider>
        </CampusImage>
        <ThumbNailSlider className="thumbnail-slider-wrap" dir={dir}>
          <Slider {...settingsThumbs} asNavFor={nav1} ref={(slider) => setSlider2(slider)}>
            {ourCampusImages.map(
              (
                image, // Still needs work
              ) => (
                <SlickSlide key={id} className={`slick-slide ${theme}`} dir={dir}>
                  {image.content.caption}
                </SlickSlide>
              ),
            )}
          </Slider>
        </ThumbNailSlider>
      </SliderWrapper>
      <CampusImageMobile>
        {mobileImage ? (
          <CampusImg>
            <LazyLoadImage
              src={mobileImage.url}
              effect="blur"
              placeholderSrc={mobileImage ? `${mobileImage.url}?width=50&quality=50` : null}
            />
          </CampusImg>
        ) : null}
        <MobilePortrait>
          <p dir={dir}>{mobileRotateMessage}</p>
        </MobilePortrait>
      </CampusImageMobile>
    </SectionCampus>
  );
}
